import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Crud, CrudService } from '../../../core';
import { NaturezaVendaFilter } from '../filter';
import { NaturezaVenda } from '../natureza-venda';

@Injectable({
    providedIn: 'root'
})
export class NaturezaVendaCrudHttpService implements Crud<NaturezaVenda> {
    resource = 'naturezavenda';

    constructor(private crudService: CrudService) { }

    /** Pesquisa todas as naturezas de venda cadastradas */
    search(): Observable<NaturezaVenda[]> {
        return this.crudService.search<NaturezaVenda>(this.resource);
    }

    /** Pesquisa todas as naturezas de venda cadastradas utilizando os filtros informados */
    searchWithFilter(filter: NaturezaVendaFilter): Observable<NaturezaVenda[]> {
        // Params
        let params = new HttpParams();
        if (filter) {
            params = filter.createParams(params);
        }
        return this.crudService.search<NaturezaVenda>(this.resource, {params});
    }

    /** Procura uma única natureza de venda através do seu ID */
    find(id: number): Observable<NaturezaVenda> {
        return this.crudService.find<NaturezaVenda>(this.resource, id);
    }

    /** Carrega uma única natureza de venda através do seu ID */
    load(id: number): Observable<NaturezaVenda> {
        return this.crudService.load<NaturezaVenda>(this.resource, id);
    }

    /** Insere uma nova natureza de venda */
    insert(entity: NaturezaVenda): Observable<NaturezaVenda> {
        return this.crudService.insert<NaturezaVenda>(this.resource, entity);
    }

    /** Altera uma natureza de venda existente */
    update(entity: NaturezaVenda): Observable<NaturezaVenda> {
        return this.crudService.update<NaturezaVenda>(this.resource, entity);
    }

    /** Exclui uma natureza de venda através do seu ID */
    delete(id: number): Observable<string> {
        return this.crudService.delete(this.resource, id);
    }
}
